<template>
    <!-- Main Section -->
    <section id="content">
        <!-- Title -->
        <h2 class="page-title">月票繳費</h2>
        <h3 class="car-number"> {{ carNumber }}</h3>

        <div class="bill-container">
            <!-- 本期賬單 -->
            <div class="bill-section">
                <!-- <div class="bill" v-for="(bill, index) in historicalBills" :key="index"> -->

                <div class="bill-section-title">本期帳單</div>
                <div v-for="(currentBill, index) in currentBills" class="current-bill" :key="index">
                    <div class="bill-content">
                        <p class="bill-period-label">{{ currentBill.description }}</p>

                        <div class="bill-date">
                            {{ currentBill.date }}
                        </div>
                        <div class="bill-amount">
                            <span class="currency">$</span>{{ currentBill.amount }}
                        </div>
                        <!-- Dynamic status text & status color class -->
                        <div class="bill-status" :class="['status-' + currentBill.status]">
                            {{ currentBill.status === 'unpaid' ? '尚未繳款' : '繳款完成' }}
                        </div>

                        <div class="bill-deport-name"> {{ currentBill.DepName }}</div>
                    </div>

                    <!-- Show "繳費單" button & payment deadline only if unpaid -->
                    <div v-if="currentBill.status === 'unpaid'">
                        <button class="pay-button" @click="showBill(currentBill)">繳費單</button>
                        <div class="payment-deadline">
                            繳費期限: {{ getDueDateString(currentBill.date)  }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 歷史賬單 -->
            <div class="bill-section">
                <div class="bill-section-title-history">歷史帳單</div>

                <!-- Loop through historical bills -->
                <div class="bill" v-for="(bill, index) in historicalBills" :key="index">
                    <div class="bill-content">
                        <div class="bill-date-only">{{ bill.date }}</div>
                        <div class="bill-amount">
                            <span class="currency">$</span>{{ bill.amount }}
                        </div>
                        <div class="bill-status" :class="['status-' + bill.status]">
                            {{ bill.status === 'unpaid' ? '尚未繳款' : '繳款完成' }}
                        </div>

                        <div class="bill-deport-name"> {{ bill.DepName }}</div>

                    </div>

                    <!-- Show payment button & deadline only if status is unpaid -->
                    <div v-if="bill.status === 'unpaid'">
                        <button class="pay-button">繳費單</button>
                        <div class="payment-deadline">
                            繳費期限: {{ getDueDateString(bill.date) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'MonthTicketPayment',
    /**
     * Use props to receive the current bill
     * and historical bills from a parent component.
     */
    props: {
        carNumber: {
            type: String,
            required: true
        },
        // currentBills: {
        //     type: Array, // changed from Object to Array
        //     required: false,
        //     default: () => ([{
        //         date: '2024-11-01',
        //         description: '本期帳單',
        //         amount: 7000,
        //         status: 'unpaid',     // or 'paid'
        //         // dueDate: '2024-11-15',
        //         Bar1: '131205627',
        //         Bar2: '9712830820013222',
        //         Bar3: '131294000006000',
        //         QR_ID: '123456789012'
        //     }])
        // },
        currentBills: {
            type: Array,
            required: false,
            default: () => ( [])
            //  () => ([
            //     {
            //         date: '2024-11-01',
            //         description: '本期帳單',
            //         amount: 7000,
            //         status: 'unpaid',     // or 'paid'
            //         // dueDate: '2024-11-15',
            //         Bar1: '131205627',
            //         Bar2: '9712830820013222',
            //         Bar3: '131294000006000',
            //         QR_ID: '123456789012'
            //     }
            // ])
        },
        historicalBills: {
            type: Array,
            required: false,
            default: () => ( [])
            
            // () => ([
            //     {
            //         date: '2024-10-01',
            //         amount: 450,
            //         status: 'paid'
            //     },
            //     {
            //         date: '2024-09-01',
            //         amount: 460,
            //         status: 'paid'
            //     },
            //     {
            //         date: '2024-08-01',
            //         amount: 470,
            //         status: 'unpaid',
            //         dueDate: '2024-08-15'
            //     }
            // ])
        }
    },
    mounted() {
        console.log('月票繳費頁面已載入！');
    },
    methods: {

        getDueDateString(date) {
            //date: '2024-09-01',
            // the date format is YYYY-MM-DD , reuturn the last day of the month with that format
            const dueDate = new Date(date);
            const lastDay = new Date(dueDate.getFullYear(), dueDate.getMonth() + 1, 0);
            const year = lastDay.getFullYear();
            const month = String(lastDay.getMonth() + 1).padStart(2, '0');
            // const day = String(lastDay.getDate()).padStart(2, '0');
            const day = "25"
            return `${year}-${month}-${day}`;
        },

        showBill(bill) {

            console.log('QR_ID:', bill.QR_ID);

            // console.log('showbill:', bill);
            this.$emit('show-bill-details', {
                bankName: '台新銀行',
                bankId: '812',
                amount: bill.amount,
                accountNo: bill.Bar2,
                dueDate: this.getDueDateString(bill.date),
                barcodes: [bill.Bar1, bill.Bar2, bill.Bar3],
                depName: bill.DepName || '台灣聯通',

                QR_ID: bill.QR_ID,
            });
        }
    }
};
</script>

<style scoped>
.page-title {
    margin-bottom: 0px;
}

.car-number {
    font-family: Inter;
    font-size: 80px;
    font-weight: 700;
    line-height: 33.6px;
    color: var(--gray15);
    margin: 0 auto;
    margin-bottom: 60px;
    margin-top: 40px;
    /* text-align: left; */

}

#content {
    background-color: var(--background-gray);
    padding-bottom: 160px;
}

.bill-section-title {
    /* //styleName: 4xl/bold; */
    font-family: Inter;
    font-size: 32px;
    font-weight: 700;
    line-height: 43.52px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: var(--gray15);
    margin-bottom: 24px;
}

.bill-section-title-history {
    /* //styleName: 4xl/bold; */
    font-family: Inter;
    font-size: 32px;
    font-weight: 700;
    line-height: 43.52px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: var(--gray15);
    margin-bottom: 24px;
    margin-top: 80px;
}

/* 本期賬單和歷史賬單容器 */
.bill-container {
    margin-top: 0px;
    width: 100%;
    padding: 0 0px;
    background-color: var(--background-gray);
}

/* 賬單區域樣式 */
.bill-section {
    margin: 0 auto;
    margin-bottom: 40px;
    width: 1416px;
    background-color: transparent;
}

/* 賬單 - 本期 */
.current-bill {
    position: relative;
    background-color: #FFFFFF;
    padding: 48px;
    width: 1416px;
    height: 282px;
    border-radius: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    box-sizing: border-box;
    margin-bottom: 20px;
}

/* 賬單 - 歷史 */
.bill {
    position: relative;
    background-color: #FFFFFF;
    padding: 48px;
    width: 1416px;
    height: 282px;
    border-radius: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    box-sizing: border-box;
    margin-bottom: 20px;
}

/* 賬單內容的子元素樣式 */
.bill-date {
    position: absolute;
    font-family: Inter;
    font-size: 24px;
    font-weight: 700;
    line-height: 33.6px;
    color: var(--green03);
    /* 綠色 */
    top: 107px;
    left: 72px;
}

.bill-date-only {
    position: absolute;
    font-family: Inter;
    font-size: 24px;
    font-weight: 700;
    line-height: 33.6px;
    color: var(--green03);
    /* 綠色 */
    top: 124px;
    left: 72px;
}

.bill-amount {
    position: absolute;
    font-family: 'Inter', sans-serif;
    font-size: 64px;
    font-weight: 700;
    line-height: 78.08px;
    color: var(--gray15);
    /* 黑色 */
    text-align: right;
    top: 102px;
    right: 780px;
}

.bill-status {
    font-family: Poppins;
    font-size: 14px;
    font-weight: 700;
    line-height: 21.56px;
    color: white;
    padding: 6px 8px;
    border-radius: 8px;
    position: absolute;
    top: 125px;
    right: 666px;
}

.bill-deport-name {
    font-family: Inter;
    font-size: 40px;
    font-weight: 700;
    line-height: 30px;
    color: var(--gray13);
    color:black;

    position: absolute;
    top: 41px;
    left: 72px;
    margin: 0px;
}

.status-unpaid {
    background-color: var(--red02);
    /* 紅色 */
}

.status-paid {
    background-color: var(--green01);
    /* 綠色 */
}

.bill-period-label {
    font-family: Inter;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    color: var(--gray13);
    position: absolute;
    top: 141px;
    left: 72px;
    margin: 0px;
}

/* 按鈕樣式 */
.pay-button {
    background-color: var(--green03);
    /* 綠色 */
    color: white;
    padding: 16px 32px;
    border: none;
    border-radius: 99px;
    cursor: pointer;
    width: 208px;
    min-height: 48px;
    height: 58px;
    transition: background-color 0.3s;
    font-family: Inter;
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    position: absolute;
    top: 112px;
    right: 72px;
}

.pay-button:hover {
    background-color: var(--green01);
    /* 更深的綠色 */
}

/* 紅色的繳費期限 */
.payment-deadline {
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    color: var(--red02);
    position: absolute;
    top: 178px;
    left: 1156.5px;
}

/* 佈局 */
.bill-content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
}

@media (max-width: 560px) {

    #content {
        padding-bottom: 80px;
    }


    .car-number {
        font-family: Inter;
        font-size: 40px;
        font-weight: 700;
        line-height: 33.6px;
        color: var(--gray15);
        margin: 0 auto;
        margin-bottom: 20px;
        margin-top: 10px;
    }

    .bill-section {
        width: 343px;
    }

    .bill-section-title {
        font-family: Inter;
        font-size: 20px;
        font-weight: 700;
        line-height: 30px;
        color: var(--gray15);
        margin-bottom: 8px;

    }


    .current-bill {
        width: 343px;
        height: 306px;
        border-radius: 20px;
    }

    .bill {
        width: 343px;
        height: 164px;
        border-radius: 20px;
    }




    .bill-date {
        font-size: 20px;
        top: 20px;
        left: 20px;
    }

    .bill-date-only {
        font-size: 20px;
        top: 20px;
        left: 20px;
    }

    .bill-period-label {
        font-size: 16px;
        top: 22px;
        left: 150px;
    }

    .bill-amount {
        font-size: 40px;
        top: 107px;
        right: 178px;
    }

    .bill-status {
        top: 129px;
        right: 90px;
    }

    .pay-button {
        width: 303px;
        height: 42px;
        font-size: 14px;
        top: 212px;
        right: 20px;
    }

    .payment-deadline {
        top: 262px;
        left: 88px;
    }

    .bill .bill-amount {
        top: 77px;
    }

    .bill .bill-status {
        top: 101px;
    }

    .bill-deport-name {
        font-size: 25px;
        top: 54px;
        left: 20px;
    }

}
</style>
